import { createUseStyles } from "react-jss";
import { colors } from "../../../../styles/colors";
const useStyles = createUseStyles({
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "13px",
    minWidth: "187px",
    borderRadius: "15px",
    backgroundColor: colors.surface,
    border: `1px solid ${colors.borderLight}`,
    padding: "20px",
    height: "fit-content",
    minHeight: "203px",
    maxHeight: "203px",
  },
  subContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
  },
  subContainer2: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  contratTitle: {
    color: colors.primary,
  },
  containerHeader: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  iconButton: { margin: 0, padding: 0 },
  scroll: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    overflow: "auto",
  },
});

export default useStyles;
